<template>
    <div v-if="locations != null" class="vehicle-page-flow__location-picker">
        <button v-for="(location,index) in locations" :key="index" @click="handleLocationChange(location)" type="button"
            class="vehicle-page-flow__location-picker-item"
            :class="{ 'vehicle-page-flow__location-picker-item--active': location.id == pickedLocation.id }">
            <img :src="location.icon.url" :width="location.icon.width" :height="location.icon.height" loading="lazy" alt="">
            <p v-html="location.name"></p>
        </button>
    </div>
</template>
<script>
export default {
    name: "locationPicker",
    props: ['locations', 'pickedLocation'],
    data() {
        return {
            culture: "da-DK",
        };
    },
    created() {
        this.culture = document.querySelector("html").getAttribute("lang");
    },
    methods: {
        handleLocationChange(location){
            this.$emit('locationChange',location);
        }
    }
};
</script>

